import { Button } from "barte-design-system";
import { CheckIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import type { CarouselActionsProps } from "./carousel-actions.type";
import styles from "./carousel-actions.module.css";

export const CarouselActions = ({
  onSkip,
  onAccept,
  onUndo,
  canUndo,
  disabled,
}: CarouselActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.actions}>
        <div className={styles["btn-wrapper"]}>
          <Button size="lg" variant="outline" onClick={onSkip} disabled={disabled}>
            {t("payfac.pagePendenciesCarouselSkip")}
          </Button>
        </div>
        <div className={styles["btn-wrapper"]}>
          <Button size="lg" variant="fill" onClick={onAccept} disabled={disabled}>
            <span className={styles["btn-label"]}>
              <CheckIcon weight="bold" size={14} />
              {t("payfac.pagePendenciesCarouselAccept")}
            </span>
          </Button>
        </div>
      </div>
      <div className={styles.footer}>
        <button className={styles.undo} onClick={onUndo} disabled={!canUndo}>
          {t("payfac.pagePendenciesCarouselUndo")}
          <span className={styles["kbd-inline"]}>⌘Z</span>
        </button>
        <span className={styles.hint}>{t("payfac.pagePendenciesCarouselHint")}</span>
      </div>
    </div>
  );
};
